import { useEffect, useState } from 'react';
import { ClientStatus } from '../../../../model/ClientStatus';
import { useClient } from '../../../../context/ClientStatusContext';
import { fetchNovelizovanyPredpisList } from '../../../../client/external/indexer/predpisZbierkyListClient';
import PredpisZbierky from '../../../../model/legislativnyMaterial/PredpisZbierky';

interface ReturnType {
  novelizovanyPredpisList: PredpisZbierky[];
  novelizovanyPredpisListStatus: ClientStatus;
}

export default (
  dopyt: string,
  limit: number,
): ReturnType => {
  const [, setAction] = useState<NodeJS.Timeout>(undefined);
  const {
    wrapClient,
    status,
    data,
  } = useClient(fetchNovelizovanyPredpisList);

  useEffect(() => {
    setAction(prevState => {
      clearTimeout(prevState);
      return prevState;
    });

    const act = setTimeout(async () => {
      await wrapClient(dopyt, limit);
    }, 300);

    setAction(act);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dopyt, limit]);

  return {
    novelizovanyPredpisList: data || [],
    novelizovanyPredpisListStatus: status,
  };
};
